export type RowCrudStatus =
  | "empty"
  | "added"
  | "added-deleted"
  | "added-updated"
  | "original-updated"
  | "original-updated-deleted"
  | "original"
  | "original-deleted";

export const isOriginalCrudStatus = (status: RowCrudStatus) => {
  return (
    status === "original-updated" ||
    status === "original-updated-deleted" ||
    status === "original" ||
    status === "original-deleted"
  );
};

export const originalDeletedStatusList: RowCrudStatus[] = [
  "original-deleted",
  "original-updated-deleted",
];
export const originalUpdatedStatusList: RowCrudStatus[] = ["original-updated"];
export const addedStatusList: RowCrudStatus[] = ["added", "added-updated"];
export const actualStatusList: RowCrudStatus[] = [
  "added",
  "added-updated",
  "original",
  "original-updated",
];

export const updatedStatus = (status: RowCrudStatus) => {
  if (isOriginalCrudStatus(status)) {
    return "original-updated";
  }
  return status;
};

export const deleteStatus = (status: RowCrudStatus) => {
  if (status === "original") {
    return "original-deleted";
  } else if (status === "original-updated") {
    return "original-updated-deleted";
  } else if (status === "added-updated") {
    return "added-deleted";
  } else if (status === "added") {
    return "added-deleted";
  }
  return status;
};

export const restoredStatus = (status: RowCrudStatus) => {
  if (status === "original-deleted") {
    return "original";
  } else if (status === "original-updated-deleted") {
    return "original-updated";
  } else if (status === "added-deleted") {
    return "added";
  }
  return status;
};

export type FileCRUDType = {
  __status__: RowCrudStatus;
  ticket?: string;
  id: string;
  name: string;
  description?: string;
  mimetype: string;
  encoding?: string;
  size: number;
  url?: string;
  formattedSize: string;
};

export const fileCRUDInit = () => {
  return {
    __status__: "empty" as RowCrudStatus,
    id: "",
    ticket: "",
    name: "",
    mimetype: "",
    size: 0,
    formattedSize: "0",
  };
};

export type OneRowCrud<T> = {
  id: string;
  __status__: RowCrudStatus;
} & T;

export type RowsCrud<T> = {
  [name: string]: OneRowCrud<T>;
};

export type CrudRows = Record<
  string,
  {
    __status__: RowCrudStatus;
    id: string;
    [name: string]: any;
  }
>;

export type CrudRow = {
  __status__: RowCrudStatus;
  id: string;
  [name: string]: any;
};

export type FooterCell = {
  value: string | number;
  sx?: Record<string, any>;
};

export type FooterData = Record<string, FooterCell>;

// Tipos para grillas (reemplazan @devexpress/dx-react-grid)
export interface GridColumn {
  name: string;
  title?: string;
  width?: number | string;
  // El tipo del campo, cuando la celda lo necesita para mostrarse: "Date" es un día de
  // calendario ("AAAA-MM-DD"), que los compactos muestran con el formateador del idioma.
  fieldType?: string;
}

export interface GridChangeSet {
  added?: any[];
  changed?: { [key: string]: any };
  deleted?: (string | number)[];
}

export interface GridFilter {
  columnName: string;
  operation?: string;
  value?: any;
}
